(function() {
    window.c24Lp.getMatomoEventCategory = function() {

        const pageType = window.c24LpPageType ? window.c24LpPageType : '';
        const pageTitle = window.c24LpPageTitle ? window.c24LpPageTitle : '';

        if (pageType === 'SEO') {
            return pageTitle.toLowerCase().replace(/_/g, ':').replace('rs:', 'rs:seo:');
        }

        return pageTitle.toLowerCase().replace(/_/g, ':');
    };

    window.c24Lp.createClickTracking = function(selector, dataAttributes, action, parentSelector = null) {
        const eventHandler = function() {
            const dataElement = parentSelector ? $(this).closest(parentSelector) : $(this);
            let nameParts = [];

            dataAttributes.forEach(attr => {
                const dataValue = dataElement.data(attr);
                if (dataValue) {
                    nameParts.push(dataValue);
                }
            });

            if (nameParts.length > 0) {
                const name = nameParts.join(':');
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    `${action}:click`,
                    name,
                ]);
            }
        };

        if (typeof selector === 'string') {
            if (parentSelector) {
                $(parentSelector).on('click', selector, eventHandler);
            } else {
                $(selector).on('click', eventHandler);
            }
        } else {
            $(selector).on('click', eventHandler);
        }
    };

    window.c24Lp.createIntersectionCallback = function createIntersectionCallback(trackedSet, dataAttributes, eventAction, matomoCategory) {
        return function(entries) {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }
                if (trackedSet.has(entry.target)) {
                    return;
                }
                const nameParts = [];
                dataAttributes.forEach(attr => {
                    const value = $(entry.target).data(attr);
                    if (value) {
                        nameParts.push(value);
                    }
                });
                if (nameParts.length > 0) {
                    window._paq.push([
                        'trackEvent',
                        matomoCategory,
                        eventAction,
                        nameParts.join(':'),
                    ]);
                    trackedSet.add(entry.target);
                }
            });
        };
    };

    window.c24Lp.createTileCallback = function createTileCallback(eventAction, dataAttributes) {
        return window.c24Lp.createIntersectionCallback(
            new Set(),
            dataAttributes,
            eventAction,
            window.c24Lp.getMatomoEventCategory(),
        );
    };

    window.c24Lp.setupTileObserver = function setupTileObserver(callback, selector, options) {
        const observer = new IntersectionObserver(callback, options);
        const targets = document.querySelectorAll(selector);

        targets.forEach((target) => {
            observer.observe(target);
        });

        return observer;
    };
})();
